// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-size: 12px;
}

.paginationExtends {
    float: right;
    text-align: right;
    padding-top: 10px;
}

.breadcrumb {
    padding-bottom: 20px;
}

.btnAdd {
    float: right;
    width: 200px;
}

.dropDown {
    width: 100%;
}

.inlineInput {
    display: inline;
}

.actionButton {
    float: right;
}

.btnDetails {
    float: right;
}

.btnAction {
    width: 180px;
}

.btnActionHidden {
    display: none;
}

.headerCenter {
    text-align: center;
}

.supplier_detail {
    margin-top: 10px;
}

.fob article .list_content_action {
    /* display: flex; */
    /* margin-bottom: 10px !important; */
}

.my-group-row {
    background-color: #0a7c76;
    font-weight: bold;
    padding: 5px;
}

/* Target group rows (assuming group data has a 'group' property) */
.ant-btn-primary {
    background-color: #1e5f85;
}

.so-column-setting {
    width: 200px;
    min-height: -moz-fit-content;
    min-height: fit-content;
    height: auto;
}

.article-column-setting {
    width: 200px;
    min-height: -moz-fit-content;
    min-height: fit-content;
    height: auto;
}

.supplier-column-setting {
    width: 200px;
    min-height: -moz-fit-content;
    min-height: fit-content;
    height: auto;
}

.column-setting {
    width: 200px;
    min-height: -moz-fit-content;
    min-height: fit-content;
    height: auto;
}

.labelCenter .ant-form-item-label {
    text-align: center !important;
}

.ant-segmented .ant-segmented-item-selected {
    color: #078297 !important;
}

/* table supplier */
#tblSupplierList .ant-table-thead th {
    text-align: center;
}

/* table article */
#tbNPL .ant-table-thead th {
    text-align: center;
}

/* table master file */
#tblMF .ant-table-thead th {
    text-align: center;
}

/* table invoice */
#tblSO .ant-table-thead th {
    text-align: center;
}

/* table BOM */
#tblBOM .ant-table-thead th {
    text-align: center;
}

#table .ant-table-thead th {
    text-align: center;
}

/* column setting for table SO,MF, Category */
/* #column_setting .ant-form-item-control-input {
    min-height:fit-content;
} */
form#column_setting.ant-form-small .ant-form-item .ant-form-item-control-input {
    min-height: -moz-fit-content !important;
    min-height: fit-content !important;
}

.ant-btn
    .ant-space.ant-space-horizontal.ant-space-align-center.ant-space-gap-row-small.ant-space-gap-col-small:not(
        .actionButton
    ) {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

/* .ant-space-horizontal.ant-space-align-center.ant-space-gap-row-small.ant-space-gap-col-small {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
} */
body[data-theme='dark'] .ant-menu-item-selected,
body[data-theme='dark'] .ant-menu .ant-menu-item-selected {
    background-color: #2f4060;
}

body[data-theme='dark'] .ant-table-wrapper .ant-table-tbody .ant-table-row.ant-table-row-selected > .ant-table-cell {
    background: #2f4060;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type='number'] {
    -moz-appearance: textfield;
    display: inline;
    text-align: right;
    width: 100%;
}

/* input[type='text'] {
    display: inline-block;
    text-align: right;
} */
.modal_container {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .inner_modal {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        width: 300px;
        height: 200px;
        border-radius: 6px;
        box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.25);
        background-color: #ffffff;

        .modal_body {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 65%;
            padding: 10px;
        }

        .modal_foot {
            display: flex;
            justify-content: center;
            align-items: center;

            button {
                padding: 10px;
                margin: 0 5px;
            }
        }
    }

    .btn_close {
        position: absolute;
        right: 0;
        top: 0;
        padding: 10px;
    }
}

.guard_btn {
    font-size: 16px;
    padding: 10px 20px;
    height: 50px;
    background-color: #222;
    color: #b4bed2;
    border: none;
}

.dragHandler:hover {
    cursor: move;
    /* background-color: #ccc; */
    transition: 0.3s;
}
body[data-theme='dark'] .dragHandler:hover {
    cursor: move;
    /* background-color: #2f4060; */
    transition: 0.3s;
}
.dragHandler {
    transition: 0.3s;
}

.react-resizable {
    position: relative;
    background-clip: padding-box;
}

.react-resizable-handle {
    position: absolute;
    width: 20px;
    height: 100%;
    bottom: 0;
    right: -10px;
    cursor: col-resize;
    z-index: 1;
}

@media (max-width: 576px) {
    .ant-picker-panels {
        flex-direction: column;
    }
}

.tblChart table {
    font-size: small;
}

.ant-form-item-required {
    flex-direction: row-reverse;
}

.ant-form-item-required::before {
    margin-left: 4px;
}

.ant-form-item-required::after {
    width: 0;
    margin: 0 !important;
}

th:has(.dragHandler) {
    padding: 0px 16px !important;
}

.searchSpace > :first-child {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.redirect .ant-card-cover img:hover {
    transform: scale(0.9);
}

.redirect .ant-card-cover img {
    transition: transform 330ms ease-in-out;
}

.redirect .ant-card-cover {
    overflow: hidden;
    background-color: white;
    
}

.bg-dark-mode {
    background: #1b2531;
}

#mnSetting .ant-menu-item {
    margin-top: 0 !important;
    border-radius: 0 !important;
}

#mnSetting .ant-card {
    overflow: hidden;
}

.ant-tree {
    background-color: inherit !important;
}

.ant-table-content .ant-tree-treenode {
    margin-bottom: 0px;
    height: 25px;
}

.ant-space-item .ant-select {
    width: 100%;
}

.ant-btn.in-active {
    opacity: 0.5;
    transition: all 0.5 ease;
}

.ant-btn.in-active:hover {
    opacity: 1;
}

.ant-table-cell .ant-tree {
    width: 250px;
}

.ant-table-cell .ant-tree-switcher {
    display: flex;
    justify-content: center;
    align-items: center;
}

.ant-tree .ant-tree-switcher:not(.ant-tree-switcher-noop):hover {
    background-color: unset;
}
.table-action {
    margin: 0px;
    padding: 0px;
    font-size: 1em;
}

.tag-status {
    padding: 8px 20px;
    border-radius: 100px; 
    display: flex;
    justify-content: center;
    align-items: center;
    width: -moz-fit-content;
    width: fit-content;
}

.tag-status .circle {
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    background-color: black;
    margin-right: 8px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.card-disabled {
    opacity: 0.5;
    cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;AAChB;;AAEA,mEAAmE;AACnE;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,4BAAuB;IAAvB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,4BAAuB;IAAvB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,4BAAuB;IAAvB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,4BAAuB;IAAvB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;AACtB;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;AACtB;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;AACtB;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;AACtB;;AAEA,cAAc;AACd;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,6CAA6C;AAC7C;;GAEG;AACH;IACI,uCAAkC;IAAlC,kCAAkC;AACtC;;AAEA;;;;IAII,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;;;;;GAKG;AACH;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,gCAAgC;AAChC;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA,YAAY;AACZ;IACI,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;;;GAGG;AACH;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB;QACI,kBAAkB;QAClB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,eAAe;QACf,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,4CAA4C;QAC5C,yBAAyB;;QAEzB;YACI,aAAa;YACb,uBAAuB;YACvB,mBAAmB;YACnB,WAAW;YACX,aAAa;QACjB;;QAEA;YACI,aAAa;YACb,uBAAuB;YACvB,mBAAmB;;YAEnB;gBACI,aAAa;gBACb,aAAa;YACjB;QACJ;IACJ;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,MAAM;QACN,aAAa;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,4BAA4B;IAC5B,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,+BAA+B;IAC/B,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,QAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;;AAE3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,4EAA4E;AAChF;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":["body {\n    font-size: 12px;\n}\n\n.paginationExtends {\n    float: right;\n    text-align: right;\n    padding-top: 10px;\n}\n\n.breadcrumb {\n    padding-bottom: 20px;\n}\n\n.btnAdd {\n    float: right;\n    width: 200px;\n}\n\n.dropDown {\n    width: 100%;\n}\n\n.inlineInput {\n    display: inline;\n}\n\n.actionButton {\n    float: right;\n}\n\n.btnDetails {\n    float: right;\n}\n\n.btnAction {\n    width: 180px;\n}\n\n.btnActionHidden {\n    display: none;\n}\n\n.headerCenter {\n    text-align: center;\n}\n\n.supplier_detail {\n    margin-top: 10px;\n}\n\n.fob article .list_content_action {\n    /* display: flex; */\n    /* margin-bottom: 10px !important; */\n}\n\n.my-group-row {\n    background-color: #0a7c76;\n    font-weight: bold;\n    padding: 5px;\n}\n\n/* Target group rows (assuming group data has a 'group' property) */\n.ant-btn-primary {\n    background-color: #1e5f85;\n}\n\n.so-column-setting {\n    width: 200px;\n    min-height: fit-content;\n    height: auto;\n}\n\n.article-column-setting {\n    width: 200px;\n    min-height: fit-content;\n    height: auto;\n}\n\n.supplier-column-setting {\n    width: 200px;\n    min-height: fit-content;\n    height: auto;\n}\n\n.column-setting {\n    width: 200px;\n    min-height: fit-content;\n    height: auto;\n}\n\n.labelCenter .ant-form-item-label {\n    text-align: center !important;\n}\n\n.ant-segmented .ant-segmented-item-selected {\n    color: #078297 !important;\n}\n\n/* table supplier */\n#tblSupplierList .ant-table-thead th {\n    text-align: center;\n}\n\n/* table article */\n#tbNPL .ant-table-thead th {\n    text-align: center;\n}\n\n/* table master file */\n#tblMF .ant-table-thead th {\n    text-align: center;\n}\n\n/* table invoice */\n#tblSO .ant-table-thead th {\n    text-align: center;\n}\n\n/* table BOM */\n#tblBOM .ant-table-thead th {\n    text-align: center;\n}\n\n#table .ant-table-thead th {\n    text-align: center;\n}\n\n/* column setting for table SO,MF, Category */\n/* #column_setting .ant-form-item-control-input {\n    min-height:fit-content;\n} */\nform#column_setting.ant-form-small .ant-form-item .ant-form-item-control-input {\n    min-height: fit-content !important;\n}\n\n.ant-btn\n    .ant-space.ant-space-horizontal.ant-space-align-center.ant-space-gap-row-small.ant-space-gap-col-small:not(\n        .actionButton\n    ) {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n/* .ant-space-horizontal.ant-space-align-center.ant-space-gap-row-small.ant-space-gap-col-small {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n} */\nbody[data-theme='dark'] .ant-menu-item-selected,\nbody[data-theme='dark'] .ant-menu .ant-menu-item-selected {\n    background-color: #2f4060;\n}\n\nbody[data-theme='dark'] .ant-table-wrapper .ant-table-tbody .ant-table-row.ant-table-row-selected > .ant-table-cell {\n    background: #2f4060;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n/* Firefox */\ninput[type='number'] {\n    -moz-appearance: textfield;\n    display: inline;\n    text-align: right;\n    width: 100%;\n}\n\n/* input[type='text'] {\n    display: inline-block;\n    text-align: right;\n} */\n.modal_container {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    .inner_modal {\n        position: relative;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-wrap: wrap;\n        width: 300px;\n        height: 200px;\n        border-radius: 6px;\n        box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.25);\n        background-color: #ffffff;\n\n        .modal_body {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            height: 65%;\n            padding: 10px;\n        }\n\n        .modal_foot {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n\n            button {\n                padding: 10px;\n                margin: 0 5px;\n            }\n        }\n    }\n\n    .btn_close {\n        position: absolute;\n        right: 0;\n        top: 0;\n        padding: 10px;\n    }\n}\n\n.guard_btn {\n    font-size: 16px;\n    padding: 10px 20px;\n    height: 50px;\n    background-color: #222;\n    color: #b4bed2;\n    border: none;\n}\n\n.dragHandler:hover {\n    cursor: move;\n    /* background-color: #ccc; */\n    transition: 0.3s;\n}\nbody[data-theme='dark'] .dragHandler:hover {\n    cursor: move;\n    /* background-color: #2f4060; */\n    transition: 0.3s;\n}\n.dragHandler {\n    transition: 0.3s;\n}\n\n.react-resizable {\n    position: relative;\n    background-clip: padding-box;\n}\n\n.react-resizable-handle {\n    position: absolute;\n    width: 20px;\n    height: 100%;\n    bottom: 0;\n    right: -10px;\n    cursor: col-resize;\n    z-index: 1;\n}\n\n@media (max-width: 576px) {\n    .ant-picker-panels {\n        flex-direction: column;\n    }\n}\n\n.tblChart table {\n    font-size: small;\n}\n\n.ant-form-item-required {\n    flex-direction: row-reverse;\n}\n\n.ant-form-item-required::before {\n    margin-left: 4px;\n}\n\n.ant-form-item-required::after {\n    width: 0;\n    margin: 0 !important;\n}\n\nth:has(.dragHandler) {\n    padding: 0px 16px !important;\n}\n\n.searchSpace > :first-child {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.redirect .ant-card-cover img:hover {\n    transform: scale(0.9);\n}\n\n.redirect .ant-card-cover img {\n    transition: transform 330ms ease-in-out;\n}\n\n.redirect .ant-card-cover {\n    overflow: hidden;\n    background-color: white;\n    \n}\n\n.bg-dark-mode {\n    background: #1b2531;\n}\n\n#mnSetting .ant-menu-item {\n    margin-top: 0 !important;\n    border-radius: 0 !important;\n}\n\n#mnSetting .ant-card {\n    overflow: hidden;\n}\n\n.ant-tree {\n    background-color: inherit !important;\n}\n\n.ant-table-content .ant-tree-treenode {\n    margin-bottom: 0px;\n    height: 25px;\n}\n\n.ant-space-item .ant-select {\n    width: 100%;\n}\n\n.ant-btn.in-active {\n    opacity: 0.5;\n    transition: all 0.5 ease;\n}\n\n.ant-btn.in-active:hover {\n    opacity: 1;\n}\n\n.ant-table-cell .ant-tree {\n    width: 250px;\n}\n\n.ant-table-cell .ant-tree-switcher {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.ant-tree .ant-tree-switcher:not(.ant-tree-switcher-noop):hover {\n    background-color: unset;\n}\n.table-action {\n    margin: 0px;\n    padding: 0px;\n    font-size: 1em;\n}\n\n.tag-status {\n    padding: 8px 20px;\n    border-radius: 100px; \n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: fit-content;\n}\n\n.tag-status .circle {\n    display: inline-block;\n    width: 14px;\n    height: 14px;\n    border-radius: 100%;\n    background-color: black;\n    margin-right: 8px;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n.card-disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
